import { Style, TargetOptionType, InputType, InfoBoxLayoutType, Preconditions } from 'common/questionnaires/types';

const questionDataStore = [
  {
    id: 'INDIVIDUAL',
    questionText: 'preQualifyingQuestionnaire.INDIVIDUAL.questionText',
    style: Style.Card,
    inputs: {
      type: InputType.YesNo,
      buttonTitles: [
        'Yes', 'No'
      ]
    },
    setsPrecondition: Preconditions.CustomerRecordNameIsIndividual,
    target: {
      type: InputType.YesNo,
      buttonTargets: [
        { type: TargetOptionType.Question, nextQuestionId: 'US-INCOME-INDIVIDUAL' },
        { type: TargetOptionType.Question, nextQuestionId: 'US-INCOME-ENTITY' }]
    }
  },
  {
    id: 'US-INCOME-ENTITY',
    questionText: 'preQualifyingQuestionnaire.USINCOME.questionText',
    style: Style.Card,
    inputs: {
      type: InputType.YesNo,
      buttonTitles: [
        'Yes', 'No'
      ]
    },
    target: {
      type: InputType.YesNo,
      buttonTargets: [
        { type: TargetOptionType.Question, nextQuestionId: 'DBA-DRE' },
        { type: TargetOptionType.Form, formTitle: 'CRS-E', formType: 'crse' },
      ]
    }
  },
  {
    id: 'US-INCOME-INDIVIDUAL',
    questionText: 'preQualifyingQuestionnaire.USINCOME.questionText',
    style: Style.Card,
    inputs: {
      type: InputType.YesNo,
      buttonTitles: [
        'Yes', 'No'
      ]
    },
    target: {
      type: InputType.YesNo,
      buttonTargets: [
        { type: TargetOptionType.Question, nextQuestionId: 'US-CITIZEN' },
        { type: TargetOptionType.Question, nextQuestionId: 'CP' },
      ]
    }
  },
  {
    id: 'CP',
    questionText: 'preQualifyingQuestionnaire.CP.questionText',
    style: Style.Card,
    inputs: {
      type: InputType.YesNo,
      buttonTitles: [
        'Yes', 'No'
      ]
    },
    target: {
      type: InputType.YesNo,
      buttonTargets: [
        { type: TargetOptionType.Form, formTitle: 'CRS-CP', formType: 'crscp' },
        { type: TargetOptionType.Form, formTitle: 'CRS-I', formType: 'crsi' },
      ]
    }
  },
  {
    id: 'DBA-DRE',
    questionText: 'preQualifyingQuestionnaire.DBA-DRE.questionText',
    style: Style.Embedded,
    inputs: {
      type: InputType.YesNo,
      buttonTitles: [
        'Yes', 'No'
      ]
    },
    setsPrecondition: Preconditions.CustomerRecordNameIsDRE,
    target: {
      type: InputType.YesNo,
      buttonTargets: [
        { type: TargetOptionType.Question, nextQuestionId: 'LEGAL-SOLE-OWNER-INDIVIDUAL' },
        { type: TargetOptionType.Question, nextQuestionId: 'US-INCORPORATED' }
      ]
    }
  }, {
    id: 'LEGAL-SOLE-OWNER-INDIVIDUAL',
    questionText: 'preQualifyingQuestionnaire.LEGAL-SOLE-OWNER-INDIVIDUAL.questionText',
    style: Style.Embedded,
    inputs: {
      type: InputType.YesNo,
      buttonTitles: [
        'Yes', 'No'
      ]
    },
    setsPrecondition: Preconditions.LegalOrSoleOwnerIsIndividual,
    target: {
      type: InputType.YesNo,
      buttonTargets: [
        { type: TargetOptionType.Question, nextQuestionId: 'LEGAL-SOLE-OWNER-INDIVIDUAL-NAME' },
        { type: TargetOptionType.Question, nextQuestionId: 'LEGAL-SOLE-OWNER-ENTITY-NAME' }]
    }
  },
  {
    id: 'LEGAL-SOLE-OWNER-INDIVIDUAL-NAME',
    questionText: 'preQualifyingQuestionnaire.LEGAL-SOLE-OWNER-INDIVIDUAL-NAME.questionText',
    style: Style.Embedded,
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'First', required: true }, { placeholder: 'Middle', required: false }, { placeholder: 'Last', required: true }
      ]
    },
    errorMessage: 'First and last name are required.',
    target: {
      type: InputType.TextFields,
      target: { type: TargetOptionType.Question, nextQuestionId: 'US-CITIZEN' }
    }
  },
  {
    id: 'LEGAL-SOLE-OWNER-ENTITY-NAME',
    questionText: 'preQualifyingQuestionnaire.LEGAL-SOLE-OWNER-ENTITY-NAME.questionText',
    style: Style.Embedded,
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Entity Name', required: true }
      ]
    },
    errorMessage: 'Entity name is required.',
    target: {
      type: InputType.TextFields,
      target: { type: TargetOptionType.Question, nextQuestionId: 'US-INCORPORATED' }
    }
  },
  {
    id: 'US-INCORPORATED',
    questionText: 'preQualifyingQuestionnaire.US-INCORPORATED.questionText',
    informationBoxComplexReferences: {
      type: InfoBoxLayoutType.ParagraphFollowedBySingleList,
      paragraph: 'preQualifyingQuestionnaire.US-INCORPORATED.informationText.p1',
      listReferences: ['preQualifyingQuestionnaire.US-INCORPORATED.informationText.li1', 'preQualifyingQuestionnaire.US-INCORPORATED.informationText.li2']
    },
    style: Style.Card,
    inputs: {
      type: InputType.YesNo,
      buttonTitles: [
        'Yes', 'No'
      ]
    },
    target: {
      type: InputType.YesNo,
      buttonTargets: [
        { type: TargetOptionType.Form, formTitle: 'W-9', formType: 'w9_2018' },
        { type: TargetOptionType.Question, nextQuestionId: 'REMAINING-W8' }
      ]
    }
  },
  {
    id: 'US-CITIZEN',
    questionText: 'preQualifyingQuestionnaire.US-CITIZEN.questionText',
    informationBoxReference: 'preQualifyingQuestionnaire.US-CITIZEN.informationText',
    style: Style.Card,
    inputs: {
      type: InputType.YesNo,
      buttonTitles: [
        'Yes', 'No'
      ]
    },
    target: {
      type: InputType.YesNo,
      buttonTargets: [
        { type: TargetOptionType.Form, formTitle: 'W-9', formType: 'w9_2018' },
        { type: TargetOptionType.Question, nextQuestionId: 'EFFECTIVE-CONNECTED-INCOME' }]
    }
  },
  {
    id: 'REMAINING-W8',
    questionText: 'preQualifyingQuestionnaire.REMAINING-W8.questionText',
    informationBoxReference: 'preQualifyingQuestionnaire.REMAINING-W8.informationText',
    style: Style.Card,
    inputs: {
      type: InputType.Select,
      buttonTitles: [
        'W-8BEN-E', 'W-8IMY', 'W-8ECI', 'W-8EXP'
      ]
    },
    target: {
      type: InputType.Select,
      buttonTargets: [
        { type: TargetOptionType.Form, formTitle: 'W-8BEN-E', formType: 'w8bene_2021' },
        { type: TargetOptionType.Form, formTitle: 'W-8IMY', formType: 'w8imy_2017' },
        { type: TargetOptionType.Form, formTitle: 'W-8ECI', formType: 'w8eci_2021' },
        { type: TargetOptionType.Form, formTitle: 'W-8EXP', formType: 'w8exp' }]
    }
  },
  {
    id: 'EFFECTIVE-CONNECTED-INCOME',
    questionText: 'preQualifyingQuestionnaire.EFFECTIVE-CONNECTED-INCOME.questionText',
    informationBoxReference: 'preQualifyingQuestionnaire.EFFECTIVE-CONNECTED-INCOME.informationText',
    style: Style.Card,
    inputs: {
      type: InputType.YesNo,
      buttonTitles: [
        'Yes', 'No'
      ]
    },
    target: {
      type: InputType.YesNo,
      buttonTargets: [
        { type: TargetOptionType.Form, formTitle: 'W-8ECI', formType: 'w8eci_2021' },
        { type: TargetOptionType.Form, formTitle: 'W-8BEN', formType: 'w8ben_2021' }
      ]
    }
  }
];

export default questionDataStore;
